import { EventCatalogFilters, EventOffersRepository } from '@lib/api/repository/event-offers/event-offers.repository';

import { CatalogPageDTO, createCatalogPage } from '../catalog/models';
import { Requester } from '../clients';
import { ProductOfferDTO, createProductOffer } from '../products';

export default class EventOffersAPI implements EventOffersRepository {
  async cards(eventId: string, filters: EventCatalogFilters, signal?: AbortSignal) {
    const { data } = await Requester.get<CatalogPageDTO>(
      `/marketplace/events/${encodeURIComponent(eventId)}/offers`,
      { signal, params: { ...filters } },
    );

    return createCatalogPage(data);
  }

  async products(eventId: string, page: number, signal?: AbortSignal) {
    const { data } = await Requester.get<{ items: ProductOfferDTO[]; total: number }>(
      `/marketplace/events/${encodeURIComponent(eventId)}/products`,
      { signal, params: { page } },
    );

    return { items: data.items.map(createProductOffer), total: data.total };
  }
}
